
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.655 9.114L2 5.471 5.655 1.83M10.674 1.829l3.655 3.642-3.655 3.643M8.967 1l-1.96 8.9","stroke":"#fff","stroke-width":"1.5","stroke-miterlimit":"10"}})])
          )
        }
      }
    